import { useQuery } from '@tanstack/react-query';
import { getSports, getThemesRef, getFormats, getRaceTypes } from '@/api/referenceService';
import { queryKeys } from '@/lib/queryKeys';

export const useSports = () =>
  useQuery({
    queryKey: queryKeys.pv2Sports,
    queryFn: getSports,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });

export const useThemesRef = () =>
  useQuery({
    queryKey: queryKeys.pv2ThemesRef,
    queryFn: getThemesRef,
    staleTime: 60 * 1000,
    refetchOnMount: 'always',
  });

export const useFormats = () =>
  useQuery({
    queryKey: queryKeys.pv2Formats,
    queryFn: getFormats,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });

export const useRaceTypes = () =>
  useQuery({
    queryKey: queryKeys.pv2RaceTypes,
    queryFn: getRaceTypes,
    staleTime: 5 * 60 * 1000,
  });
